import React from 'react';

export default ({ className }) => (
  <svg className={className}width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M10.8 0H2C1.448 0 1 0.448 1 1V9L2 8V1H10V4.5C10 4.776 10.224 5 10.5 5H14V15H2V14C2 12.067 3.56702 10.5 5.5 10.5H8V13L11 10L8 7V9.5H5.5C3.01471 9.5 1 11.5147 1 14V15C1 15.552 1.448 16 2 16H14C14.552 16 15 15.552 15 15V4.429C15 4.173 14.902 3.926 14.726 3.74L11.526 0.312C11.337 0.113 11.074 0 10.8 0Z"/>
  </svg>
);
